<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Tips')"
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form label-width="60px" label-position="left">
      <el-form-item :label="$t('CargoMsg.Cargo_ReconciliationDiffReason')">
        <el-input v-model="reason" style="width: 220px;" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" no="ok" @click="ok">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ReconciliationDiffConfirmDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      reason: ''
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.reason = ''
      }
    }
  },
  methods: {
    ok() {
      if (!this.reason) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReconciliationDiffReason') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      this.$emit('returnCall', this.reason)
      this.innerVisible = false
    }
  }
}
</script>

